import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notfound',
  templateUrl: './app.notfound.component.html',
  styleUrls: ['./app.notfound.component.css'],

  standalone: false,})
export class AppNotfoundComponent {
  title: string = 'SBVP';

  constructor() {
    this.title = environment.applicationTitle;
  }
}
